import React from "react";
import { Route } from "react-router-dom";
import Header from "../Header";
import Nav from "../Nav";
import Main from "../Main";
// import Dashboard from "../Dashboard";
import AppFrame from "../AppFrame";
import Buildings from "../Buildings";
import Cities from "../Cities";
import Communities from "../Communities";
import Users from "../Users";
import Businesses from "../Businesses";
import Categories from "../Categories";
import FoodOrderingManagement from "../FoodOrderingManagement";
import SuperQuickLinks from "../QuickLinks/SuperQuickLinks";
import Offers from "../Offers";
import Business from "../Business";
import Building from "../Building";

const Portal = () => (
  <AppFrame>
    <Header title="Hilo Admin" />
    <Nav />
    <Main>
      {/* <Route exact path="/" component={Dashboard} /> */}
      <Route path="/buildings" component={Buildings} />
      <Route path="/cities" component={Cities} />
      <Route path="/neighborhoods" component={Communities} />
      <Route path="/users" component={Users} />
      <Route path="/businesses" component={Businesses} />
      <Route path="/categories" component={Categories} />
      <Route path="/foodorder" component={FoodOrderingManagement} />
      <Route path="/superquicklinks" component={SuperQuickLinks} />
      <Route path="/offers" component={Offers} />
      <Route path="/business/:id" component={Business} />
      <Route path="/building/:id" component={Building} />
    </Main>
  </AppFrame>
);

export default Portal;
